import getOfferAgreement from "astrid-firestore/src/api/offers/utils/getOfferAgreement";

import { useProfile } from "../../authentication/state/profile";

export default function useOfferAgreement(offer) {
	const user = useProfile();

	return getOfferAgreement({ offer, user });
}
